<template>
  <div class="">
    <sticky class="page-header sticky-page-header page-header--new"
            :back-button="false" :calendarMonth="gApiReady && !googleLogged"
            :classOnRightSlot="'columns is-gapless is-narrow'">
      <div slot="left" class="columns is-vcentered is-gapless">
        <div class="column is-3 minW300p maxW300p has-bg-black is-self-stretched has-text-white columns is-gapless is-vcentered">
          <div class="column is-padding-left">
            <span v-if="panel === 'RDVS'">{{total}} RDV programmés</span>
            <span v-else-if="panel === 'REMINDERS'">{{total}} RAPPELS programmés</span>
          </div>
        </div>
        <div v-if="range_date !== rangeDateInit" @click="initialDate()" class="column is-narrow is-border-right" style="border-color: white">
          <a class="page-header-btn is-small has-text-black-ter">
            <span class="icon"><i class="far fa-clock is-size-4"></i></span><span
                  class=" is-padding-left-xxsmall has-text-weight-medium">ACTIONS À VENIR</span>
          </a>
        </div>
        <div v-else class="column is-narrow is-border-left" style="border-color: white">
          <span class="page-header-btn has-bg-black is-small has-text-black-ter">
            <span class="has-text-white-ter icon"><i class="far fa-clock is-size-4"></i></span><span
                  class="has-text-white-ter is-padding-left-xxsmall has-text-weight-medium">ACTIONS À VENIR</span>
          </span>
        </div>
        <div @click="goToMonthLeft()" class="control is-margin-left">
          <button class="button is-square is-border button is-small is-transform-none is-grey is-border is-inverted">
            <i class="fal fa-chevron-left"></i>
          </button>
        </div>
        <div @click="goToMonthRight()" class="control is-margin-left-xsmall">
          <button class="button is-square is-border button is-small is-transform-none is-grey is-border is-inverted">
            <i class="fal fa-chevron-right"></i>
          </button>
        </div>
        <div class="column is-narrow is-self-stretched is-flex">
          <div class="is-self-centered has-text-centered is-padding-left">
            <div class="title is-size-5 is-size-4-widescreen"><b class="is-uppercase">{{currentMonth|monthFormat}}</b>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-self-centered is-padding-right-small" slot="left-action">
        <button @click="goToDay()" class="button is-small is-transform-none is-grey is-border is-inverted">
          <span class="has-text-grey has-text-weight-medium">Aujourd'hui</span>
        </button>
        <button @click="goToCurrentMonth()" class="button is-small is-transform-none is-grey is-border is-inverted">
          <span class="has-text-grey has-text-weight-medium">Mois</span>
        </button>
      </div>
      <a v-if="gApiReady && !googleLogged" @click="googleLogin()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fab fa-google"></i></span><span>Connexion google agenda</span>
      </a>
      <!-- <a @click="newRdv" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-calendar-plus"></i></span>
        <span>Nouveau rendez-vous</span>
      </a>
      <a @click="newReminder" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-alarm-clock"></i></span>
        <span>Nouveau rappel</span>
      </a> -->
      <a @click="open" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-calendar-plus"></i></span>
        <span>Nouvelle action</span>
      </a>
      <a @click="loadItems()" class="dropdown-item" slot="dropdown-content">
        <span class="icon"><i class="fas fa-sync"></i></span>
        <span>Actualiser</span>
      </a>
      <google-sync-button slot="left-action"></google-sync-button>
    </sticky>
    <spinner-round :isLoading="forceLoading" v-if="forceLoading"></spinner-round>
    <div v-else class="page-content columns is-gapless collapseColumn collapseColumn--left collapseColumn--left--small collapseColumn--alignStart" id="columns-collapse">
      <div class="column is-3 has-bg-white is-border-right">
        <div class="has-flatpickr-responsive has-flatpickr-theme--s1 has-flatpickr-padding-h has-bg-white-ter is-border-bottom is-padding-bottom-small">
          <flat-pickr :config="configDateMini"
                      id="flatpickr"
                      class="input is-hidden is-radiusless is-shadowless flatpickr-input is-noDecalPosTop"
                      name="date"
                      @input="updateRangeDateFilter"
                      v-model="range_date"
          ></flat-pickr>
        </div>
        <div>
          <div v-if="hasFilter"
               class="is-padding-left-small is-padding-top-xsmall is-padding-bottom-xsmall is-border-top has-bg-annonce">
            <a class="has-text-white is-size-6" @click.prevent.stop="resetFiltersNoMixin">
              <span class="icon"><i class="fas fa-undo"></i></span>
              <span class="is-italic">Réinitialiser tous les filtres</span>
            </a>
          </div>
          <div v-if="panel === 'RDVS'"
               class="column is-gapless is-12 columns is-multiline is-vcentered is-paddingless-bottom is-padding-top-small is-padding-left-small is-padding-right-small">
            <label for="" class="label is-transform-none has-text-grey is-padding-bottom-xsmall">Type de
              rendez-vous</label>
            <div class="column is-12 columns is-variable is-1 is-multiline">
              <div v-for="type in rdvTypeList" :key='type.value'
                   class="column is-3 is-paddingless-top is-paddingless-bottom is-paddingless-left">
                <input :id="type.value" v-model="filters.rdv_type" :value="type.label" name="typeRdv"
                       :class="{'is-active' : filters.rdv_type.map(x=> x.value).includes(type.value)}"
                       checked="checked" class="checkradiocase is-primary is-fullwidth" type="checkbox"
                       @change="updateRdvType(filters.rdv_type, `#${type.value}`)">
                <label :for="type.value">{{type.label}}</label>
              </div>
            </div>
          </div>
          <div v-if="isAdmin || isSectorManager || panel === 'RDVS'"
               class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openSellerSelectionQuickView('author')" class="input">
                <div v-if="filters.author && filters.author.length">
                  <span class="">organisateurs ({{filters.author.length}})</span>
                </div>
                <span v-else class="has-text-grey">Sélectionner organisateur</span>
              </div>
            </div>
          </div>
          <div v-if="panel === 'RDVS'" class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openContactSelectionQuickView()" class="input">
                <div v-if="filters.contact && filters.contact.length">
                  <span class="">contacts ({{filters.contact.length}})</span>
                </div>
                <span v-else class="has-text-grey">Rechercher contact</span>
              </div>
            </div>
          </div>
          <div v-if="panel === 'RDVS'" class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openSellerSelectionQuickView('participant')" class="input">
                <div v-if="filters.seller && filters.seller.length">
                  <span class="">participants ({{filters.seller.length}})</span>
                </div>
                <span v-else class="has-text-grey">Rechercher participant</span>
              </div>
            </div>
          </div>
          <div v-if="(isAdmin || isSectorManager) && panel === 'RDVS'"
               class="is-padding-left-small is-padding-right-small is-padding-top-small">
            <div class="control">
              <div @click="openPoleSelectionQuickView()" class="input">
                <div v-if="filters.pole">
                  <span class="">{{pole.name}}</span>

                </div>
                <span v-else class="has-text-grey">Rechercher Pôle</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column is-paddingless contained-min-height-inter">
        <div class="tabs is-small is-marginless-bottom has-bg-white is-border-bottom">
          <ul class="has-text-weight-medium is-borderless">
            <li :class="{'is-active':panel === 'RDVS'}"><a @click="changePanel('RDVS')"
                                                           :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'RDVS'}"><b
                    class="is-uppercase">Rendez-vous</b></a></li>
            <li :class="{'is-active':panel === 'REMINDERS'}" class="is-border-left"><a @click="changePanel('REMINDERS')"
                                                                                       :class="{'router-link-exact-active is-active has-bg-white-ter':panel === 'REMINDERS'}"><b
                    class="is-uppercase">Rappels</b></a></li>
          </ul>
        </div>
        <div class="column has-bg-light is-self-stretched is-paddingless">
          <div v-if='panel === "RDVS"' class="column is-narrow columns is-vcentered is-border-right">
            <label class="checkbox checkRadioIsHide is-padding-right-xsmall" :for="s.value" v-for="s in qualifications"
                   :key="s.value">
              <input type="checkbox" :id="s.value" v-model="qualification" @click="changeQualificationFilter(s.value)"
                     :value="s.value">
              <span class="tag" :class="s.value | rdvColor">
                <span>{{s.label}}</span>
                <span class="icon"><i class="far"
                                      :class="s.value ? qualificationSelected === s.value ? 'fa-check-circle' : 'fa-circle' : 'fa-times'"></i></span>
              </span>
            </label>
          </div>
          <div class="is-border-top">
            <div class="is-padding" v-if="hasFilter">
              <label for="" class="is-size-6 label is-padding-bottom-small">Vos critères de recherche :</label>
              <div class="tags">
                <span class="tag is-primary is-rounded" v-if="filters.author && filters.author.length"
                      v-for="(auth, i) in author">
                  {{auth.last_name}} {{auth.first_name}} <a @click="deleteAuth(i)"
                                                            class="icon is-white is-margin-left-xsmall"><i
                        class="fas fa-times-circle has-text-white"></i></a>
                </span>
                <span class="tag is-primary is-rounded" v-if="filters.contact && filters.contact.length"
                      v-for="(cont, i) in contact">
                  {{cont.last_name}} {{cont.first_name}} <a @click="deleteContact(i)"
                                                            class="icon is-white is-margin-left-xsmall"><i
                        class="fas fa-times-circle has-text-white"></i></a>
                </span>
                <span class="tag is-primary is-rounded" v-if="filters.seller && filters.seller.length"
                      v-for="(sel, i) in seller">
                  {{sel.last_name}} {{sel.first_name}} <a @click="deleteSeller(i)"
                                                          class="icon is-white is-margin-left-xsmall"><i
                        class="fas fa-times-circle has-text-white"></i></a>
                </span>
                <span class="tag is-primary is-rounded" v-if="filters.pole && filters.pole">
                  {{pole.name}} <a @click="updateKeyFilter(null, 'pole')" class="icon is-white is-margin-left-xsmall"><i
                        class="fas fa-times-circle has-text-white"></i></a>
                </span>
                <span class="tag is-primary is-rounded" v-if="filters.rdv_type && filters.rdv_type.length"
                      v-for="(type, i) in filters.rdv_type" :key="'type-' + i">
                  {{type}} <a @click="deleteTypeFilter(i)" class="icon is-white is-margin-left-xsmall"><i
                        class="fas fa-times-circle has-text-white"></i></a>
                </span>
                <span class="tag is-primary is-rounded"
                      v-if="filters.date__gte && filters.date__lte && (filters.date__lte !== initFilters.date__lte || filters.date__gte !== initFilters.date__gte)">
                  <span v-if="uniqueDate">{{uniqueDate}}</span>
                  <span v-else>{{startTagDate}} - {{endTagDate}}</span> <a @click="range_date = null"
                                                                           class="icon is-white is-margin-left-xsmall"><i
                        class="fas fa-times-circle has-text-white"></i></a>
                </span>
                <span class="tag is-annonce is-rounded has-cursor-pointer" @click="resetFiltersNoMixin">
                  Réinitialiser les filtres <span class="icon is-white is-margin-left-xsmall"><i
                        class="fas fa-undo"></i></span>
                </span>
              </div>
            </div>
            <calendar-list-rdv v-if='panel === "RDVS"' :sentItems='items' :loading='loading' :totalPage='totalPage' :nextPage="nextPage" @deleteItem='deleteItem' @loadMore='loadMore'></calendar-list-rdv>
            <calendar-list-reminder v-if='panel === "REMINDERS"' :sentItems='items' :loading='loading' :totalPage='totalPage' :nextPage="nextPage" @deleteItem='deleteItem' @loadMore='loadMore'></calendar-list-reminder>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce, intersection, orderBy, uniq, isPlainObject } from 'lodash'
  import moment from 'moment'
  import { mapGetters, mapState } from 'vuex'
  import { Filter, GenericList, DefaultValues, GoogleMx } from '@/mixins'
  import CalendarRdvItem from './CalendarRdvItem'
  import GoogleSyncButton from './GoogleSyncButton'
  import CalendarListRdv from './CalendarListRdv'
  import CalendarListReminder from './CalendarListReminder'

  export default {
    name: 'CalendarList',
    mixins: [Filter, GenericList, DefaultValues, GoogleMx],
    components: { CalendarRdvItem, GoogleSyncButton, CalendarListRdv, CalendarListReminder },
    data () {
      return {
        forceLoading: true,
        rangeFromCode: false,
        rangeDateInit: null,
        panel: 'RDVS',
        myRdv: false,
        currentMonth: moment(),
        currentMonthAdd: moment(),
        currentMonthSubstract: moment(),
        formatedCurrentMonth: null,
        infiniteLoaderEnabled: true,
        rdvTypeList: {
          R0: { value: 'R0', label: 'R0' },
          R1: { value: 'R1', label: 'R1' },
          R2: { value: 'R2', label: 'R2' },
          R3: { value: 'R3', label: 'R3' }
        },
        configDateMini: {
          mode: 'range',
          inline: true,
          enableTime: false,
          noCalendar: false,
          dateFormat: 'd/m/Y',
          time_24hr: true
        },
        columnsConfResource: 'rendez-vous',
        fromClick: false,
        infiniteLoading: false,
        items: [],
        authors: [],
        poles: [],
        pole: null,
        author: [],
        contact: [],
        seller: [],
        currentPage: 1,
        total: null,
        bigTotal: null,
        opened: true,
        displayMyRdvs: false,
        currentEvent: null,
        selectedEvent: null,
        perPage: 100,
        calendarReportsData: this.calendarReports,
        filters: {
          contact: [],
          seller: [],
          author: [],
          rdv_type: [],
          successful: null,
          canceled: null,
          deferred: null,
          pole: null
        },
        initFilters: {
          contact: [],
          seller: [],
          author: [],
          rdv_type: [],
          successful: null,
          canceled: null,
          deferred: null,
          pole: null
        },
        loading: true,
        tab: 'futureRdvs',
        qualification: null,
        qualificationSelected: null,
        loadDocuments: this.loadItems,
        configDate: {
          altFormat: 'j/m/y',
          altInput: true,
          dateFormat: 'd/m/Y',
          mode: 'range'
        },
        uniqueDate: null,
        startTagDate: null,
        endTagDate: null,
        range_date: null,
        myRdvs: [],
        rdvLoading: false,
        currentDay: moment.utc(moment()).format('DD/MM/YYYY HH:mm'),
        futureRdvsTotal: null,
        futureRdvs: [],
        futureRdvTotalPage: null,
        futureRdvCurrentPage: null,
        futureRdvsLoading: false,
        pastRdvs: [],
        pastRdvsTotal: null,
        pastRdvTotalPage: null,
        pastRdvCurrentPage: null,
        qualifications: [
          { value: 'successful', label: 'Effectué' },
          { value: 'deferred', label: 'Reporté' },
          { value: 'canceled', label: 'Annulé' },
          { value: null, label: 'Tous' }
        ]
      }
    },
    filters: {
      monthFormat (v) {
        return moment(v).format('MMMM YYYY')
      },
      dotClass (v) {
        if (v.successful) return 'has-bg-success'
        else if (v.canceled) return 'has-bg-danger'
        else if (v.deferred) return 'has-bg-warning'
        else return 'has-bg-draft'
      },
      rdvLabel (v) {
        if (v.successful) return 'Effectué'
        else if (v.canceled) return 'Annulé'
        else if (v.deferred) return 'Reporté'
        else return 'Non qualifié'
      },
      rdvColor (v) {
        const COLORS = {
          successful: 'is-success',
          canceled: 'is-danger',
          deferred: 'is-warning'
        }
        if (v in COLORS) return COLORS[v]
        else return 'is-draft'
      },
      date: function (value) {
        let date = moment(value).format('DD/MM/YY')
        let hour = moment(value).format('HH')
        let minute = moment(value).format('mm')
        return date + ' - ' + hour + 'h' + minute
      }
    },
    watch: {
      currentMonth (v) {
        this.formatedCurrentMonth = v.isValid() ? v.toDate() : moment.toDate()
      },
      quickview ({ mode, params, results }) {
        if (results) {
          if (mode === 'SELLER_SELECTION') {
            if (params.type === 'author') {
              results.entities.forEach(x => {
                this.author.push(x)
                this.filters.author.push(x)
              })
              this.$nextTick(() => {
                this.changeFilters()
              })
            } else if (params.type === 'participant') {
              results.entities.forEach(x => {
                this.seller.push(x)
                this.filters.seller.push(x)
              })
              this.$nextTick(() => {
                this.changeFilters()
              })
            }
          } else if (mode === 'CONTACT_SELECTION') {
            results.entities.forEach(x => {
              this.contact.push(x)
              this.filters.contact.push(x)
            })
            this.$nextTick(() => {
              this.changeFilters()
            })
          } else if (mode === 'POLE_SELECTION') {
            this.updatePoleFilter(results.entities[0])
          } else if (mode === 'NEW_CALENDAR_ACTION') {
            console.log(results.val)
            let day
            let month
            let year
            if ('reminder' in results.val && results.val.reminder) {
              let date = moment(results.val.reminder.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year, panel: 'REMINDERS' } })
            } else if ('rdv' in results.val && results.val.rdv) {
              let date = moment(results.val.rdv.date)
              day = date.get('date')
              month = date.get('month')
              month = month + 1
              year = date.get('year')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
            }
          }
        }
      }
    },
    computed: {
      ...mapState({
        scrollToEl: 'scrollToEl',
        scrollToPage: 'scrollToPage',
        googleLogged: 'googleLogged',
        currentUser: 'currentUser',
        quickview: 'quickview',
        polesList: 'poles'
      }),
      ...mapGetters(['currentUserPk', 'isAdmin', 'isSectorManager', 'isManager', 'isOperator', 'isSeller']),
      service () {
        if (this.panel === 'RDVS') {
          return this.$api.rdvService
        } else if (this.panel === 'REMINDERS') {
          return this.$api.reminderService
        }
      },
      today () {
        return moment()
      },
      rdvs () {
        return this.displayMyRdvs ? this.myRdvs.slice() : this.items.slice()
      },
      rdvList () {
        let rdvList = []
        if (!this.fromClick) {
          this.successScroll()
        }
        if (this.listedEvents && this.listedEvents.length) {
          return this.listedEvents.map(x => {
            let date = moment(x.date).format('DD/MM/YYYY')
            if (rdvList.includes(date) === false) {
              this.$set(x, 'showDayLabel', true)
              rdvList.push(date)
            }
            return x
          })
        }
      },
      listedEvents () {
        let listedEvents = []
        let rdvs = []
        let order = 'desc'
        if (this.tab === 'pastRdvs') rdvs = this.pastRdvs
        else {
          rdvs = this.futureRdvs
          order = 'asc'
        }
        rdvs.forEach(x => {
          let wrapper = {
            event: Object.assign({}, x),
            date: x.date,
            showDayLabel: false
          }
          listedEvents.push(wrapper)
        })
        return orderBy(listedEvents, x => {
          return moment(x.date)
        }, order)
      },
      currentMonthDate () {
        return moment(this.formatedCurrentMonth).format('DD/MM/YYYY')
      },
      todayMonthDate () {
        return moment().format('DD/MM/YYYY')
      }
    },
    methods: {
      open () {
        this.$store.commit('setQuickview', {mode: 'NEW_CALENDAR_ACTION'})
      },
      deleteSeller (i) {
        if (Array.isArray(this.filters.seller)) {
          this.filters.seller.splice(i, 1)
          this.seller.splice(i, 1)
        } else {
          this.$set(this.filters, 'seller', [])
          this.$set(this, 'seller', [])
        }
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      deleteAuth (i) {
        if (Array.isArray(this.filters.author)) {
          this.filters.author.splice(i, 1)
          this.author.splice(i, 1)
        } else {
          this.$set(this.filters, 'author', [])
          this.$set(this, 'author', [])
        }
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      deleteContact (i) {
        if (Array.isArray(this.filters.contact)) {
          this.filters.contact.splice(i, 1)
          this.contact.splice(i, 1)
        } else {
          this.$set(this.filters, 'contact', [])
          this.$set(this, 'contact', [])
        }
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      initialDate () {
        this.currentMonth = this.today.clone()
        this.allRdvList(true)
      },
      async resetFiltersNoMixin () {
        this.filters = {
          seller: [],
          author: [],
          rdv_type: [],
          successful: null,
          canceled: null,
          deferred: null,
          pole: null,
          contact: []
        }
        this.qualificationSelected = null
        this.qualification = null
        this.contact = []
        this.author = []
        this.seller = []
        this.$set(this, 'query', this.filters)
        await this.allRdvList()
        this.changeFilters()
      },
      updateSellerFilter (e) {
        this.$set(this.filters, 'seller', e.pk)
        this.$set(this, 'seller', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateContactFilter (e) {
        this.$set(this.filters, 'contact', e.pk)
        this.$set(this, 'contact', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      openPoleSelectionQuickView () {
        this.$store.commit('setQuickview', { mode: 'POLE_SELECTION' })
      },
      openContactSelectionQuickView () {
        let params = {
          mode: 'append'
        }
        this.$store.commit('setQuickview', { mode: 'CONTACT_SELECTION', params: params })
      },
      openSellerSelectionQuickView (value) {
        let params = {}
        params.type = value
        params.facets = {
          'USER': ['is_external:False']
        }
        this.$store.commit('setQuickview', { mode: 'SELLER_SELECTION', params: params })
      },
      changePanel (panel) {
        this.panel = panel
        this.items = []
        this.resetFiltersNoMixin()
      },
      goToCurrentMonth () {
        this.$router.push({ name: 'CalendarMonthView', query: { date: this.formatedCurrentMonth } })
      },
      goToMonthLeft () {
        let d = this.currentMonth.clone()
        d.subtract(1, 'months')
        this.currentMonth = d.clone()
        this.changeDate()
      },
      goToMonthRight () {
        let d = this.currentMonth.clone()
        d.add(1, 'months')
        this.currentMonth = d.clone()
        this.changeDate()
      },
      changeDate () {
        let dateLte = moment(this.currentMonth, 'DD/MM/YYYY').endOf('month')
        this.endTagDate = dateLte.format('DD/MM/YYYY')
        let dateGte = moment(this.currentMonth, 'DD/MM/YYYY').startOf('month')
        let dateGteMore = moment(this.currentMonth, 'DD/MM/YYYY').startOf('month').add(2, 'hours')
        this.startTagDate = dateGte.format('DD/MM/YYYY')
        this.$set(this.filters, 'date__lte', dateLte.utc().format('DD/MM/YYYY HH:mm'))
        this.$set(this.filters, 'date__gte', dateGte.utc().format('DD/MM/YYYY HH:mm'))
        this.$set(this.initFilters, 'date__lte', dateLte.utc().format('DD/MM/YYYY HH:mm'))
        this.$set(this.initFilters, 'date__gte', dateGte.utc().format('DD/MM/YYYY HH:mm'))
        this.range_date = dateGteMore.format('DD/MM/YYYY') + ' au ' + dateLte.format('DD/MM/YYYY')
        this.$set(this.configDateMini, 'defaultDate', this.range_date)
      },
      async allRdvList (first = false) {
        let dateGte = moment(this.currentMonth, 'DD/MM/YYYY').startOf('day')
        this.$set(this.initFilters, 'date__gte', dateGte.utc().format('DD/MM/YYYY HH:mm'))
        this.$set(this.filters, 'date__gte', dateGte.utc().format('DD/MM/YYYY HH:mm'))
        let dateGteMore = moment(this.currentMonth, 'DD/MM/YYYY').startOf('day').add(2, 'hours')
        this.startTagDate = dateGte.format('DD/MM/YYYY')
        let requestParams = {
          date__gte: dateGte.utc().format('DD/MM/YYYY HH:mm'),
          sort: 'date:desc'
        }
        let rdvs = await this.$api.rdvService.get(requestParams)
        if (rdvs.data.items.length) {
          rdvs = rdvs.data.items
          let lastRdvDate = rdvs[0].date
          let dateLte = new Date(lastRdvDate)
          dateLte = moment(dateLte, 'DD/MM/YYYY').endOf('day')
          this.endTagDate = dateLte.format('DD/MM/YYYY')
          this.$set(this.filters, 'date__lte', dateLte.utc().format('DD/MM/YYYY HH:mm'))
          this.$set(this.initFilters, 'date__lte', dateLte.utc().format('DD/MM/YYYY HH:mm'))
          this.range_date = dateGteMore.format('DD/MM/YYYY') + ' au ' + dateLte.format('DD/MM/YYYY')
          this.$set(this.configDateMini, 'defaultDate', this.range_date)
          if (first) {
            this.rangeDateInit = dateGteMore.format('DD/MM/YYYY') + ' au ' + dateLte.format('DD/MM/YYYY')
          }
        }
      },
      goToYear (val, dateStr, instance) {
        let d = this.currentMonth.clone()
        let comparator = Number(`${instance.currentYear}${instance.currentMonth < 10 ? `0${instance.currentMonth}` : instance.currentMonth}`)
        if (d.format('YYYYMM') - 1 < comparator) {
          d.add(1, 'year')
        } else if (d.format('YYYYMM') - 1 > comparator) {
          d.subtract(1, 'year')
        } else {
          d = this.today.clone()
        }
        this.currentMonth = d.clone()
        this.changeDate()
      },
      updateMyRdvs () {
        if (this.myRdv) {
          this.$set(this.filters, 'seller', null)
        } else {
          this.$set(this.filters, 'seller', this.currentUserPk)
        }
        this.myRdv = !this.myRdv
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      newReminder () {
        this.$store.commit('setQuickview', { mode: 'NEW_REMINDER' })
      },
      newRdv () {
        this.$router.push({ name: 'CalendarCreate' })
      },
      goToDay (e) {
        let day
        let month
        let year
        if (e) {
          let date = moment(e)
          day = date.get('date')
          month = date.get('month')
          month = month + 1
          year = date.get('year')
        } else if (this.formatedCurrentMonth) {
          let date = moment(this.formatedCurrentMonth)
          day = date.get('date')
          month = date.get('month')
          month = month + 1
          year = date.get('year')
        }
        this.$router.push({ name: 'CalendarDayView', query: { day, month, year } })
      },
      googleLogin () {
        window.gapi.auth2.getAuthInstance().signIn().then(res => {
        })
      },
      deletePoleFilter: debounce(function (i) {
        if (Array.isArray(this.filters.pole)) this.filters.pole.splice(i, 1)
        else this.$set(this.filters, 'pole', [])
        this.filters.pole.splice(i, 1)
        this.$nextTick(() => {
          this.changeFilters()
        })
      }, 200),
      deleteTypeFilter: debounce(function (i) {
        if (Array.isArray(this.filters.rdv_type)) this.filters.rdv_type.splice(i, 1)
        else this.$set(this.filters, 'rdv_type', [])
        this.$nextTick(() => {
          this.changeFilters()
        })
      }, 200),
      updateKeyFilter (e, key) {
        this.$set(this.filters, key, e)
        this[key] = e
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      beforeResetFilters () {
        this.uniqueDate = null
        this.startTagDate = null
        this.endTagDate = null
        this.range_date = null
        this.author = []
        this.seller = []
      },
      beforeGet () {
        this.$set(this, 'query', Object.assign({}, this.query, this.filters))
        if (Array.isArray(this.query.pole)) {
          this.query.pole = uniq(this.query.pole.map(x => x.pk || x))
        }
        if (Array.isArray(this.query.contact)) {
          this.query.contact = uniq(this.query.contact.map(x => x.pk || x))
        }
        if (Array.isArray(this.query.author)) {
          this.query.author = uniq(this.query.author.map(x => x.pk || x))
        }
        if (Array.isArray(this.query.seller)) {
          this.query.seller = uniq(this.query.seller.map(x => x.pk || x))
        }
        if (isPlainObject(this.query.pole)) {
          this.query.pole = [this.query.pole.pk]
        }
      },
      getAuthors (query) {
        let profilsPk = []
        if (this.profilOrderList && this.profilOrderList.length) {
          profilsPk = this.profilOrderList.filter(x => !x.is_external).map(x => x.pk)
        }
        let params = {
          profil: profilsPk
        }
        if (query) params.query = query
        this.$api.userService.get(params).then(r => {
          this.authors = r.data.items
        })
      },
      setTab (val) {
        this.$set(this, 'tab', val)
        this.saveHistory({ ...this.filters, tab: val })
      },
      changePage (e) {
        if (this.tab === 'allRdvs') this.$set(this, 'currentPage', e)
        else this.$set(this, 'myRdvCurrentPage', e)
      },
      updateRangeDateFilter: debounce(function (e) {
        console.log(e)
        // eslint-disable-next-line no-useless-return
        if (this.rangeFromCode) return
        else if (e) {
          if (!e.includes('au')) {
            let startDate = moment(e, 'DD/MM/YYYY').startOf('day')
            let endDate = moment(e, 'DD/MM/YYYY').endOf('day')
            this.uniqueDate = startDate.format('DD/MM/YYYY')
            this.$set(this.filters, 'date__lte', endDate.utc().format('DD/MM/YYYY HH:mm'))
            this.$set(this.filters, 'date__gte', startDate.utc().format('DD/MM/YYYY HH:mm'))
          } else {
            this.uniqueDate = null
            let range = e.split(' au ')
            let startDate = moment(range[0], 'DD/MM/YYYY').startOf('day')
            let endDate = moment(range[1], 'DD/MM/YYYY').endOf('day')
            this.startTagDate = startDate.format('DD/MM/YYYY')
            this.endTagDate = endDate.format('DD/MM/YYYY')
            this.$set(this.filters, 'date__lte', endDate.utc().format('DD/MM/YYYY HH:mm'))
            this.$set(this.filters, 'date__gte', startDate.utc().format('DD/MM/YYYY HH:mm'))
          }
          this.$nextTick(() => {
            this.changeFilters()
          })
        } else {
          this.allRdvList()
        }
      }, 500),
      inputChange: debounce(function () {
        this.$nextTick(() => {
          this.changeFilters()
        })
      }, 300),
      updateAuthorFilter (e) {
        this.$set(this.filters, 'author', e.pk)
        this.$set(this, 'author', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updatePoleFilter (e) {
        this.$set(this.filters, 'pole', e.pk)
        this.$set(this, 'pole', e)
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      updateRdvType (e, el) {
        this.$set(this.filters, 'rdv_type', e)
        this.$nextTick(() => {
          this.fixFocus(el)
          this.changeFilters()
        })
      },
      fixFocus (element) {
        // Debug focus persistant sur les cases à cocher (app/Maison) avec chrome
        document.querySelector(element).blur()
      },
      changeQualificationFilter (e) {
        this.qualificationSelected = e
        if (e) {
          let qualifs = ['successful', 'canceled', 'deferred']
          let filters = {}
          qualifs.forEach(x => {
            if (this.qualificationSelected === x) filters[x] = 1
            else filters[x] = 0
          })
          Object.assign(this.filters, filters)
        } else {
          this.$set(this.filters, 'successful', null)
          this.$set(this.filters, 'canceled', null)
          this.$set(this.filters, 'deferred', null)
        }
        this.$nextTick(() => {
          this.changeFilters()
        })
      },
      deleteEvent (e) {
        let selectedRdvs = this.displayMyRdvs ? this.myRdvs : this.items
        let idx = selectedRdvs.findIndex(x => x.pk === e.pk)
        if (idx >= 0) {
          selectedRdvs.splice(idx, 1)
        }
      },
      addEvent (rdv) {
        let selectedRdvs = this.displayMyRdvs ? this.myRdvs : this.items
        selectedRdvs.push(rdv)
      },
      setCurrentEvent (event) {
        this.currentEvent = event
      }
    },
    async created () {
      this.currentMonth = this.today.clone()
      this.loading = true
      this.rangeFromCode = true
      await this.allRdvList(true)
      this.query.sort = 'date:desc'
      if (this.$route.query) {
        Object.assign(this.filters, this.$route.query)
        if ('date' in this.filters) {
          delete this.filters.date
        }
        if ('sort' in this.filters) {
          delete this.filters.sort
        }
        if ('date__gte' in this.$route.query && 'date__lte' in this.$route.query) {
          let envoi = this.filters.date__gte + ' au ' + this.filters.date__lte
          this.startTagDate = this.filters.date__gte
          this.endTagDate = this.filters.date__lte
          this.range_date = envoi
        }
      }
      let qualif = intersection(['successful', 'canceled', 'deferred'], Object.keys(this.$route.query))
      if (qualif && qualif.length) {
        this.changeQualificationFilter(qualif[0])
      }
      if (this.$route.query.author) {
        const { data } = await this.$api.userService.getOne(this.$route.query.author)
        this.author = data
      }
      this.rangeFromCode = false
      await this.changeFilters()
      this.forceLoading = false
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/CalendarList.vue